import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { BUTTON_HEIGHT_20 } from '../../Button'
import { ButtonSelect } from '../../Select'
import { AISelectControlContainer } from '../AISelectControlContainer'

import {
  AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MAX_WIDTH,
  AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MIN_HEIGHT,
} from './AITextGenerationFormikButtonSelect.constants'

import * as styles from './AITextGenerationFormikButtonSelect.module.css'

function AITextGenerationFormikButtonSelect({
  controlProps,
  hideControlValue,
  listProps,
  value,
  onChange,
  onSelectItem,
  ...props
}) {
  return (
    <ButtonSelect
      {...props}
      controlProps={{
        ...controlProps,
        Container: AISelectControlContainer,
        className: styles.selectContainer,
        contentProps: {
          ...controlProps?.contentProps,
          className: styles.selectControlContent,
        },
        indicatorsProps: {
          ButtonClear: null,
          buttonArrowProps: { Element: 'span', height: BUTTON_HEIGHT_20 },
          className: styles.indicator,
        },
        value: hideControlValue ? null : value,
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.topStart,
        dropdownStyles: {
          maxWidth: AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MAX_WIDTH,
          minHeight:
            AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MIN_HEIGHT,
        },
        maxWidthByRef: false,
      }}
      listProps={{
        ...listProps,
        className: styles.dropdownList,
        headerProps: {
          ...listProps?.headerProps,
          Search: null,
        },
        itemProps: {
          ...listProps?.itemProps,
          className: styles.dropdownItem,
          contentProps: {
            ...listProps?.itemProps?.contentProps,
            infoProps: {
              ...listProps?.itemProps?.contentProps?.infoProps,
              className: styles.dropdownItemInfo,
              contentTextProps: {
                ...listProps?.itemProps?.contentProps?.infoProps
                  ?.contentTextProps,
                className: styles.dropdownItemText,
              },
            },
          },
        },
      }}
      value={value}
      onSelectItem={onChange || onSelectItem}
    />
  )
}

export default AITextGenerationFormikButtonSelect
